import { useQuery } from '@tanstack/react-query';

export function useCompanyRolesQuery({ params, queryOptions }) {
  return useQuery({
    queryKey: ['companyRoles', params],
    queryFn: async () => {
      const response = await axios.get('/company_roles', { params });

      return response.data;
    },
    ...queryOptions,
  });
}
